import type { HomeStrings } from "../../types";

export const home: HomeStrings = {
  hero: {
    title: "Acaba con la saturación de terminales en un canvas infinito.",
    subtitle: "Terminales, editores y navegadores flotando sobre una superficie infinita con zoom.",
    platforms: "macOS, Windows y Linux",
  },
  download: {
    mac: "Descargar para macOS",
    windows: "Descargar para Windows",
    linux: "Descargar para Linux",
    latest: "Descargar la última versión",
  },
  heroNewsletter: {
    placeholder: "Recibe la newsletter",
    subscribe: "Suscribirme",
    done: "Listo. Revisa tu bandeja de entrada.",
  },
  manifesto: {
    title: "No es otro gestor de ventanas.",
    body: "Las distribuciones en mosaico se limitan a recolocar las ventanas que ya tienes. Cate va de repensar cómo trabajamos y programamos ahora que los agentes de IA forman parte del flujo: un espacio de trabajo espacial por proyecto, donde tus herramientas y tus agentes comparten la misma superficie y mantienen su contexto.",
  },
  testimonials: {
    title: "Los desarrolladores están atentos",
    subtitle: "Reacciones reales del hilo de lanzamiento en Hacker News.",
  },
  downloadCta: {
    titleLines: ["Repensar el espacio de trabajo", "para la era de los agentes."],
  },
  newsletter: {
    title: "No te pierdas nada",
    body: "Recibe novedades sobre funciones nuevas, releases y trucos. Sin spam y te das de baja cuando quieras.",
    placeholder: "tu@ejemplo.com",
    subscribe: "Suscribirme",
    success: "¡Gracias por suscribirte! Revisa tu bandeja de entrada para ver el correo de bienvenida.",
    errorGeneric: "Algo ha fallado",
    errorNetwork: "Error de red, inténtalo de nuevo",
  },
  unsubscribe: {
    noEmail: "No se ha indicado ninguna dirección de correo.",
    loading: "Dándote de baja...",
    doneTitle: "Te has dado de baja",
    doneBody: "{email} ya no forma parte de la newsletter de CATE. No volverás a recibir correos nuestros.",
    back: "Volver a CATE",
    error: "Algo ha fallado. Inténtalo de nuevo.",
  },
};
